import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "24",
  fill: "none",
  viewBox: "0 0 23 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M10.875 18.75s-1.125 0-1.125-1.125 1.125-4.5 5.625-4.5S21 16.5 21 17.625s-1.125 1.125-1.125 1.125zm4.5-6.75a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75m-6.507 6.75a2.5 2.5 0 0 1-.243-1.125c0-1.525.764-3.093 2.178-4.185-.619-.198-1.34-.315-2.178-.315-4.5 0-5.625 3.375-5.625 4.5s1.125 1.125 1.125 1.125zM8.063 12a2.813 2.813 0 1 0 0-5.625 2.813 2.813 0 0 0 0 5.625"
    }, null, -1)
  ])))
}
export default { render: render }